import {mobileActive} from './handle-mobile';
import _debounce from "lodash/debounce";
import Mark from 'mark.js';
import eventBus from './event-bus';
import {bootstrapDetectBreakpoint} from './bootstrapDetectBreakpoint';


let resize;

const body = $('body');
let searchInput = $('[data-role="main-search-input"]');
const resultBox = $('[data-role="main-search-results"]');
const $resultBoxEmpty = $('[data-role="main-search-results__empty"]');
const $resultBoxEmptyMobile = $('[data-role="main-search-results__empty--mobile"]');
const $resultListContainer = $('[data-role="is-main-search__results__list__container"]');
const $resultListContainerA = $('[data-role="is-main-search__results__list__container__a"]');
const $resultListContainerB = $('[data-role="is-main-search__results__list__container__b"]');
const $resultListContainerMobile = $('[data-role="is-main-search__results__list__container__mobile"]');
const submitBtn = resultBox.find('button.button-search');
const backdropHolder = $('.is-backdrop-holder');
const searchWrap = $('.is-main-search__wrap');
const pageWidth = $('body').width();
const mobileAction = $('.is-mobile-action');
let searchTerm = '';

let searchActive = false;
let keyNavigationActive = false
let listIndex = 0;
let menu = 0;
const quickSearchCache = {};
let inputFocused = true;

function addSearchInputEventListeners() {

    searchInput.on('focus', _debounce((e) => {
        handleSearchString();
        eventBus.emit('search-focused');
        eventBus.emit('main-search-active');
        if (pageWidth <= 991) {
            mobileAction.addClass('d-none');
        }
    }, 500, {leading: true, trailing: false}));

    searchInput.on('blur', () => {
        listIndex = 0;
        if (pageWidth <= 991) {
            mobileAction.removeClass('d-none');
        }
    });

    searchInput.on('input', _debounce((e) => {
        setBackdrop();
        if (searchWrap.hasClass('is-flyout-centered') && (pageWidth > 991)) {
            body.addClass('overflow-hidden');
        }
        handleSearchString();
        searchTerm = e.target.value
        resultBox.removeClass('d-none');
        eventBus.emit('main-search-active');
        inputFocused = true;
        e.stopPropagation();
    }, 300));

    searchInput.on('keydown', function (e) {
        if (inputFocused && e.keyCode === 13) {
            $(this).trigger(submitBtn);
        }
        if (searchActive) {
            switch (e.keyCode) {
                case 38:
                    keyNavigate('up');
                    break;
                case 9:
                    keyNavigate('down');
                    e.stopPropagation();
                    e.preventDefault();
                    break;
                case 13:
                    let activeItem = $resultListContainer.find('[data-role="quicksearch-item"].active');

                    activeItem = activeItem.find('a');

                    if (activeItem.length > 0) {
                        let attr = activeItem.attr('href');
                        if (typeof attr !== 'undefined' && attr !== false) {
                            window.location.href = activeItem.attr('href');
                        }
                    }

                    e.stopPropagation();
                    e.preventDefault();
                    break;
                case 40:
                    if (!keyNavigationActive) {
                        selectFirstItem()
                        return;
                    }
                    keyNavigate('down');
                    break;
                case 37:
                    if (menu === 1) {
                        clearCurrentActive();
                        menu = 0
                        selectFirstItem();
                    }
                    break;
                case 39:
                    if (menu === 0) {
                        clearCurrentActive();
                        menu = 1
                        selectFirstItem();
                    }
                    break;
            }
        }
    });

    searchInput.on('click', function (e) {
        inputFocused = true;
        e.stopPropagation();
    });

}

resultBox.on('click', function (e) {
    e.stopPropagation();

});

submitBtn.on('click', function () {
    let form = $('form.quickSearchForm');
    form.submit();
});

function updateView() {

    /*** Get the current media breakpoint ***/
    const currentBreakpoint = bootstrapDetectBreakpoint();

    /*** Change dom selector for search field if header is sticky ***/
    if (currentBreakpoint.index > 2) {  // Check if breakpoint is larger than 'MD'

        if (!$('.is-main-navigation-bar').hasClass('pinned')) { // Check if header is sticky
            searchInput = $('.is-header').find($('[data-role="main-search-input"]'));
            addSearchInputEventListeners();
        }

        eventBus.on('pinned', function (e) { // Event was fired if header is sticky or not
            if (!e) {
                searchInput = $('.is-header').find($('[data-role="main-search-input"]'));
                closeResultBox();
                removeBackdrop();
                return;
            }
            searchInput = $('.is-main-navigation-bar').find($('[data-role="main-search-input"]'));
            closeResultBox();
            removeBackdrop();
            addSearchInputEventListeners();
        });

    } else {
        searchInput = $('.is-mobile-action-row').find($('[data-role="main-search-input"]'));
        addSearchInputEventListeners();
    }
}

function selectFirstItem() {
    listIndex = 0;
    const $firstQuicksearchResult = $resultListContainer.find('[data-role="quicksearch-item"]').eq(0);
    $firstQuicksearchResult.addClass('active');
    setValue($firstQuicksearchResult.find('[data-role="quicksearch-item-label"]'));
    keyNavigationActive = true;
}

function keyNavigate(direction) {
    const $quicksearchItems = $resultListContainer.find('[data-role="quicksearch-item"]');

    inputFocused = false;

    if (direction === 'up') {
        if (listIndex >= 1) {
            listIndex -= 1;
        }
    }
    if (direction === 'down') {
        if (listIndex <= $quicksearchItems.length - 2) {
            listIndex += 1;
        }
    }

    $resultListContainer.find('[data-role="quicksearch-item"].active').removeClass('active');
    const $quicksearchItem = $quicksearchItems.eq(listIndex);
    $quicksearchItem.addClass('active');
    setValue($quicksearchItem.find('[data-role="quicksearch-item-label"]'));
}

function handleSearchString() {
    let searchStringLength = getSearchQuery().length;

    if (searchStringLength <= 0) {
        closeResultBox();
        removeBackdrop();
        return
    }

    if (searchStringLength >= 2) {
        quickSearch();
        return
    }

    closeResultBox();
}

function quickSearch() {
    let query = getSearchQuery();

    $resultListContainer.removeClass('d-none');
    $resultListContainerMobile.removeClass('d-none');
    $resultBoxEmpty.addClass('d-none');
    $resultBoxEmptyMobile.addClass('d-none');

    if (!query || query.length < 1) {
        return closeResultBox();
    }

    if (quickSearchCache.hasOwnProperty(query)) {
        $resultListContainer.removeClass('d-none');
        $resultListContainerMobile.removeClass('d-none');
        $resultListContainer.addClass('d-flex');
        $resultBoxEmpty.addClass('d-none');
        $resultBoxEmptyMobile.addClass('d-none');
        return renderQuickSearch(quickSearchCache[query]);
    }

    let url = new URL(window.config.urls.quicksearch);
    url.searchParams.append('query', query);

    window.axios
        .get(url.toString())
        .then(({data}) => {
            if (data.success) {
                renderQuickSearch(data);
                quickSearchCache[query] = data;
            } else {
                $resultListContainer.addClass('d-none');
                $resultListContainerMobile.addClass('d-none');
                $resultListContainer.removeClass('d-flex');
                $resultBoxEmpty.removeClass('d-none');
                $resultBoxEmptyMobile.removeClass('d-none');
                openResultBox();
            }
        })
        .catch((error) => {
            console.error(error);
        });
}

function getSearchQuery() {
    const query = searchInput.val();
    const queryMobile = $('#main-search-input-mobile').val();

    if (mobileActive.status) {
        if (queryMobile && queryMobile.length > 0) {
            return queryMobile;
        }
    }
    return query;
}

function setBackdrop() {
    backdropHolder.addClass('is-backdrop');
    body.addClass('overflow-hidden');
}

function removeBackdrop() {
    backdropHolder.removeClass('is-backdrop');
    body.removeClass('overflow-hidden');
}

function openResultBox() {
    searchActive = true;
    resultBox.addClass('active');
}

function closeResultBox() {
    searchActive = false;
    resultBox.removeClass('active');
    if (searchWrap.hasClass('is-flyout-centered')) {
        body.removeClass('overflow-hidden');
    }
    resultBox.addClass('d-none');
    $resultListContainerB.html('');
}

function clearSearchFieldValue(el) {
    el.val('');
}

function clearCurrentActive() {
    $($resultListContainerB[0].children[menu].children[1].children[listIndex]).removeClass('active');
}

function setValue(el) {
    searchInput.val($(el)[0].innerText);
}

body.on('click', function (e) {
    removeBackdrop();
    closeResultBox();
})

function renderQuickSearch(response) {
    let productsWidth = 12,
        mobileHtml = '',
        html_a = '',
        html_b = '';

    let defaultTemplate = document.querySelector('script[data-template="quicksearch.item"]').innerText,
        defaultContainer = document.querySelector('script[data-template="quicksearch.container"]').innerText,
        defaultContainerMobile = document.querySelector('script[data-template="quicksearch.mobile.container"]').innerText,
        emptyTemplate = document.querySelector('script[data-template="quicksearch.empty-item"]').innerText;

    const preservedIndex = new Set(['products', 'pages', 'success', 'translations']);

    for (let index in response) {
        if (preservedIndex.has(index)) {
            continue;
        }

        if (response.hasOwnProperty(index) && (typeof response[index] === 'string' || response[index].meta.total > 0)) {
            let templateHolder = document.querySelector('script[data-template="quicksearch.' + index + '.item"]'),
                template = templateHolder !== null ? templateHolder.innerText : defaultTemplate,
                containerHolder = document.querySelector('script[data-template="quicksearch.' + index + '.container"]'),
                container = containerHolder !== null ? containerHolder.innerText : defaultContainer,
                containerMobileHolder = document.querySelector('script[data-template="quicksearch.' + index + '.mobile.container"]'),
                containerMobile = containerMobileHolder !== null ? containerMobileHolder.innerText : defaultContainerMobile,
                sectionHtml = '';

            if (typeof response[index] === 'string') {
                sectionHtml = simpleTemplate(emptyTemplate, {text: response[index]});
            } else {
                for (let item of response[index].data) {
                    sectionHtml += simpleTemplate(template, item);
                }
            }

            html_a += simpleTemplate(container, {items: sectionHtml, title: response.translations[index]});
            mobileHtml += simpleTemplate(containerMobile, {items: sectionHtml, title: response.translations[index]});
        }
    }

    productsWidth += response.productsWidthMultiplicator * 2;

    // --- Pages
    const hasPages = response.hasOwnProperty('pages') && (typeof response.pages === 'string' || response.pages.meta.total > 0);

    if (!hasPages) {
        productsWidth += 12;
    }

    // --- Products
    if (response.hasOwnProperty('products')) {
        if (typeof response.products === 'string') {
            let container = document.querySelector('script[data-template="quicksearch.products.empty-container"]').innerText,
                containerMobile = document.querySelector('script[data-template="quicksearch.products.mobile.container"]').innerText;

            html_b += simpleTemplate(container, {text: response.products, width: productsWidth});
            mobileHtml += simpleTemplate(containerMobile, {items: simpleTemplate(emptyTemplate, {text: response.products})});
        } else if (response.products.data.length > 0) {
            let templateImage = document.querySelector('script[data-template="quicksearch.products.item.image"]').innerText,
                templateNoImage = document.querySelector('script[data-template="quicksearch.products.item.noimage"]').innerText,
                container = document.querySelector('script[data-template="quicksearch.products.container"]').innerText,
                containerMobile = document.querySelector('script[data-template="quicksearch.products.mobile.container"]').innerText,
                items = '';

            for (let product of response.products.data) {
                if (product.image) {
                    items += simpleTemplate(templateImage, product);
                } else {
                    items += simpleTemplate(templateNoImage, product);
                }
            }

            html_b += simpleTemplate(container, {items, width: productsWidth});
            mobileHtml += simpleTemplate(containerMobile, {items});
        }
    }

    if (hasPages) {
        let template = document.querySelector(`script[data-template="quicksearch.pages.item"]`).innerText,
            container = document.querySelector(`script[data-template="quicksearch.pages.container"]`).innerText,
            containerMobile = document.querySelector(`script[data-template="quicksearch.pages.mobile.container"]`).innerText,
            sectionHtml = '';

        if (typeof response.pages === 'string') {
            sectionHtml = simpleTemplate(emptyTemplate, {text: response.pages})
        } else {
            for (let item of response.pages.data) {
                sectionHtml += simpleTemplate(template, item);
            }
        }

        html_a += simpleTemplate(container, {items: sectionHtml});
        mobileHtml += simpleTemplate(containerMobile, {items: sectionHtml});
    }

    $resultListContainerA.html(html_a);
    $resultListContainerB.html(html_b);
    $resultListContainerMobile.html(mobileHtml);
    openResultBox();
    highlightSearchTerm(searchTerm);
}

function simpleTemplate(template, variables) {
    for (let variable in variables) {
        if (variables.hasOwnProperty(variable)) {
            template = template.replace(new RegExp(':' + variable, 'g'), variables[variable])
        }
    }

    return template;
}

function setCenteredFlyout() {
    const containerWidth = $('.container').width();
    if (pageWidth > 991) {
        resultBox.css({
            "width": containerWidth,
            "top": "auto",
            "position": "fixed",
            "transform": "translateY(-12px)",
            "left": (pageWidth - containerWidth) / 2
        });
    } else {
        resultBox.removeAttr('style');
    }
}

if (searchWrap.hasClass('is-flyout-centered')) {
    setCenteredFlyout();
    $(window).on('resize', function () {
        clearTimeout(resize);
        resize = setTimeout(function () {
            setCenteredFlyout();
        }, 300);
    });
}

function highlightSearchTerm(keyword) {
    const context = document.querySelectorAll('[data-role="quicksearch-item"]');
    const instance = new Mark(context);
    instance.mark(keyword);
}

/*** Open mobile search input ***/
/*** ------------------------ ***/

function closeDropdown(wrapper) {
    const dropdown = wrapper.find('.dropdown');
    dropdown.find('[data-bs-toggle="dropdown"]').removeClass('show').attr('aria-expanded', 'false');
    dropdown.find('.dropdown-menu').removeClass('show').attr('style', '');
}

$('[data-role="mobileSearchBoxToggle"]').on('click', function (e) {

    const actionMenuRow = $(this).closest('.is-mobile-action-menu__row');
    const actionMenu = $(this).closest('.is-mobile-action-menu');

    if (actionMenuRow.hasClass('active')) {
        actionMenuRow.removeClass('active');
        actionMenu.removeClass('overflow-hidden');
        closeResultBox();
        removeBackdrop();
    } else {
        actionMenuRow.addClass('active');
        actionMenu.addClass('overflow-hidden');
        closeDropdown(actionMenuRow);
    }

    e.stopPropagation();
});


/*** Open search on sticky header ***/
/*** ---------------------------- ***/

function activateStickySearch(el) {
    $('#mainMenu').addClass('visually-hidden');
    el.find('i').removeClass('fa-search').addClass('fa-times')
    el.addClass('active');
    $('#mainMenuWrap').find('.main-menu-sticky-search-wrap').removeClass('d-none').addClass('d-lg-flex');
}

function deActivateStickySearch(el) {
    el.find('i').removeClass('fa-times').addClass('fa-search')
    el.removeClass('active');
    $('#mainMenu').removeClass('visually-hidden');
    $('#mainMenuWrap').find('.main-menu-sticky-search-wrap').addClass('d-none').removeClass('d-lg-flex');
}

$('[data-role="stickySearchBoxToggle"]').on('click', function (e) {
    if ($(this).hasClass('active')) {
        deActivateStickySearch($(this));
        closeResultBox();
        removeBackdrop();
        e.stopPropagation();
        return;
    }
    activateStickySearch($(this));
    e.stopPropagation();
});

/** Close search field if header loses stickiness **/
eventBus.on('pinned', function (e) {
    if (!e) {
        deActivateStickySearch($('[data-role="stickySearchBoxToggle"]'));
    }
});

/*** update view (Check screen size and if header is sticky) ***/

updateView()
window.onresize = updateView;


